export default "<!--<app-toolbar></app-toolbar>\n<app-map></app-map> -->\n\n<!-- <app-mainmenu></app-mainmenu> -->\n<router-outlet></router-outlet>";